import { StyleSheet } from '@react-pdf/renderer';
import { RegisterFont } from '../RegisterFont';

RegisterFont();

export const tableStyle = StyleSheet.create({
    table: {
        marginTop: 40,
        flexDirection: 'column',
    },
    tableHeading: {
        fontSize: 10,
        color: '#4B99F5',
        marginBottom: 6,
        fontFamily: 'Roboto',
    },
    tableHeaderRow: {
        paddingVertical: 4,
        borderBottom: '1px solid #C5E0FF',
        borderTop: '1px solid #C5E0FF',
        flexDirection: 'row',
    },
    tableRow: {
        paddingVertical: 4,
        borderBottom: '1px solid #C5E0FF',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    headerDate: {
        width: 90,
        fontSize: 6,
        color: '#4B99F5',
        fontFamily: 'Roboto',
    },
    headerDescription: {
        width: 335,
        fontSize: 6,
        color: '#4B99F5',
        fontFamily: 'Roboto',
    },
    headerTime: {
        width: 70,
        fontSize: 6,
        color: '#4B99F5',
        fontFamily: 'Roboto',
    },
    headerPercentage: {
        width: 35,
        fontSize: 6,
        color: '#4B99F5',
        fontFamily: 'Roboto',
    },
    rowDate: {
        fontSize: 8,
        color: '#455166',
        fontFamily: 'Roboto',
    },
    rowDateCell: {
        width: 90,
        paddingRight: 8,
    },
    rowDescription: {
        fontSize: 8,
        color: '#455166',
        fontFamily: 'Roboto',
        paddingRight: 8,
        lineHeight: 1.3,
    },
    rowDescriptionCell: {
        width: 335,
        flexShrink: 1,
    },
    rowTime: {
        fontSize: 8,
        color: '#455166',
        fontFamily: 'Roboto',
    },
    rowTimeCell: {
        width: 70,
        paddingRight: 8,
    },
    rowPercentage: {
        fontSize: 8,
        color: '#455166',
        textAlign: 'right',
        fontFamily: 'Roboto',
    },
    rowPercentageCell: {
        width: 35,
    },
    totalRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 6,
        fontSize: 18,
        color: '#4B99F5',
        borderBottom: '1px solid #C5E0FF',
        fontWeight: 500,
        fontFamily: 'Roboto',
    },
});
